import React,{ useRef, useState, useEffect } from "react"
import axios from "axios"
import jwt_decode from "jwt-decode"
import { useParams ,useNavigate} from "react-router-dom"
import baseURL from "../../Url/Url.jsx"
import SideBar from "../../Layout/SideBar.jsx"
import PilihPeriode from "../../Layout/PilihPeriode.jsx"

const MenuKaryawanTetap = () => {
    // variabel sistem utama
    const [alamatPerusahaan, setAlamatPerusahaan] = useState("")
    const [npwpPerusahaan, setNpwpPerusahaan] = useState("")
    const [namaPenandatangananSpt, setNamaPenandatangananSpt] = useState("")
    const [jabatanPenandatangananSpt, setJabatanPenandatangananSpt] = useState("")
    const [npwpPenandatangananSpt, setNpwpPenandatangananSpt] = useState("")
    const [perusahaan, setPerusahaan] = useState("")
    const [bulan, setBulan] = useState("Bulan")
    const [tahun, setTahun] = useState("Tahun")
    const [dataPerusahaan, setDataPerusahaan] = useState([])
    const [displayLoader, setDisplayLoader] = useState("none")
    const [, setToken] = useState("")
    const [expire, setExpire] = useState("")
    const navigate = useNavigate()
    const tableRef = useRef(null);
    const { perusahaanParams } = useParams()

    // Sistem utama
    useEffect(()=>{
        refreshToken()
        selectPerusahaan()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Refresh token
    const refreshToken = async() => {
        try {
            const response = await axios.get(`${baseURL}/tokenBE`)
            setToken(response.data.accessToken)
            const decoded = jwt_decode(response.data.accessToken)
            setPerusahaan(decoded.perusahaan)
            setBulan(decoded.bulan)
            setTahun(decoded.tahun)
            setExpire(decoded.exp)
        } catch (error) {
            if(error.response){
                navigate("/", { replace: true })
            }   
        }
    }

    const axiosJWT = axios.create()
    axiosJWT.interceptors.request.use(async(config) => {
        const currentDate = new Date()
        if(expire * 1000 < currentDate.getTime()){
            const response = await axios.get(`${baseURL}/tokenBE`)
            config.headers.Authorization = `Bearer ${response.data.accessToken}`
            setToken(response.data.accessToken)
            const decoded = jwt_decode(response.data.accessToken)
            setPerusahaan(decoded.perusahaan)
            setBulan(decoded.bulan)
            setTahun(decoded.tahun)
            setExpire(decoded.exp)
        }
        return config
    }, (error)=>{
        return Promise.reject(error)
    })

    // Logout
    const Logout = async() =>{
        try {
            await axios.delete(`${baseURL}/logoutBE`)
            navigate("/", { replace: true })
        } catch (error) {
            console.log(error)
        }
    }

    // Menyimpan perusahaan
    const createPerusahaan = async (e) => {
        e.preventDefault()
        try {
            setDisplayLoader("")
            await axios.post(`${baseURL}/createPerusahaanBE`,{
                perusahaan: perusahaan,
                alamatPerusahaan: alamatPerusahaan,
                npwpPerusahaan: npwpPerusahaan,
                namaPenandatangananSpt: namaPenandatangananSpt,
                jabatanPenandatangananSpt: jabatanPenandatangananSpt,
                npwpPenandatangananSpt: npwpPenandatangananSpt,
            })
            navigate(`/menu-perusahaan/${perusahaan}`, { replace: true })
            window.location.reload()
        } catch (error) {
            if(error.response){
                setDisplayLoader("none")
                console.log(error.response.data.msg)
            }
        }
    }

    // Mengambil perusahaan
    const selectPerusahaan = async() =>{
        try{
            const response = await axios.get(`${baseURL}/selectPerusahaanBE/${perusahaanParams}`)
            setDataPerusahaan(response.data)
        }catch(error){
            console.log(error)
        }
    }

    // Format NPWP
    const formatNPWP = (value) => {
        const parts = [
          value.slice(0, 2),
          value.slice(2, 5),
          value.slice(5, 8),
          value.slice(8, 9),
          value.slice(9, 12),
          value.slice(12, 15),
        ];
      
        let result = "";
        if (parts[0]) result += parts[0];
        if (parts[1]) result += "." + parts[1];
        if (parts[2]) result += "." + parts[2];
        if (parts[3]) result += "." + parts[3];
        if (parts[4]) result += "-" + parts[4];
        if (parts[5]) result += "." + parts[5];
      
        return result;
    };
      
    // Halaman
    return (
        <div id="wrapper">

            {/* LOADER */}
            <div className="loader-page-bg" style={{display:displayLoader}}>
                <div className="loader-page"></div>
            </div>

            {/* SIDE BAR */}
            <SideBar 
                bulanParams={bulan}
                tahunParams={tahun}
                perusahaanParams={perusahaan}
                tahunSekarang={tahun}
            />

            {/* KONTEN WRAP */}
            <div id="content-wrapper">

                {/* NAVBAR */}
                <nav className="navbar navbar-expand-sm sticky-top nav-bar py-3">
                    <div className="container">
                        <div className="dropdown ml-2">
                            <button className="navbar-toggler mb-2" data-bs-toggle="collapse" data-bs-target="#sidebar" aria-controls="sidebar" aria-expanded="false" aria-label="Toggle navigation" style={{border:"none"}}>
                                <i className="bi bi-grid-fill" style={{fontSize:"22px"}}></i>
                            </button>
                        </div>
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0"></ul>
                        <div className="d-flex" role="search">
                            <input type="text" className="form-control form" value={perusahaan} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"300px"}} readOnly/>
                            <input type="text" className="form-control form mx-2" value={bulan} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"120px",textAlign:"center"}} readOnly/>
                            <input type="text" className="form-control form" value={tahun} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"70px",textAlign:"center"}} readOnly/>
                            <button onClick={Logout} className="btn btn-logout mx-2"><i className="bi bi-power" style={{color:"white",fontSize:"22px"}}></i></button>
                        </div>
                    </div>
                </nav>

                {/* KONTEN */}
                {bulan === "JANUARI" || bulan === "FEBRUARI" || bulan === "MARET"|| bulan === "APRIL"|| bulan === "MEI"|| bulan === "JUNI"|| bulan === "JULI"|| bulan === "AGUSTUS"|| bulan === "SEPTEMBER"|| bulan === "OKTOBER"|| bulan === "NOVEMBER"|| bulan === "DESEMBER"          
                    ?<div>
                        <div className="container-fluid" style={{overflow:"auto",display:"block",width:"100%",height:"88vh"}}>
                            <h4 className="text-center my-4" style={{fontWeight:"700"}}>Menu Perusahaan</h4>
                            <div className="row">
                                <div className="col-12">
                                    <div className="px-4"style={{width: "100%",maxHeight:"430px"}}>
                                        <div className="row justify-content-center">
                                            <div className="box mb-4 py-3 px-4" style={{overflow:"auto",color:"rgb(108, 108, 108)"}}>
                                                <table ref={tableRef} className="mb-3" style={{width:"1300px"}}>
                                                    <thead>
                                                        <tr style={{fontWeight:"700"}}>
                                                            <td className="px-3 py-2" style={{width:"auto"}}>Perusahaan</td>
                                                            <td className="px-3 py-2" style={{width:"auto"}}>Alamat Perusahaan</td>
                                                            <td className="px-3 py-2" style={{width:"auto"}}>ID TKU</td>
                                                            <td className="px-3 py-2" style={{width:"auto"}}>Nama Penandatangan SPT</td>
                                                            <td className="px-3 py-2" style={{width:"auto"}}>Jabatan Penandatangan SPT</td>
                                                            <td className="px-3 py-2" style={{width:"auto"}}>TIN (CoreTax)</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {dataPerusahaan.map((user,index)=>(
                                                            <tr key={dataPerusahaan.id}>
                                                                <td className="px-3" style={{width:"auto"}}>{user.perusahaan}</td>	
                                                                <td className="px-3" style={{width:"auto"}}>{user.alamatPerusahaan}</td>	
                                                                <td className="px-3" style={{width:"auto"}}>{user.npwpPerusahaan}</td>	
                                                                <td className="px-3" style={{width:"auto"}}>{user.namaPenandatangananSpt}</td>	
                                                                <td className="px-3" style={{width:"auto"}}>{user.jabatanPenandatangananSpt}</td>	
                                                                <td className="px-3" style={{width:"auto"}}>{user.npwpPenandatangananSpt}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="box mt-1 p-4">
                                                <form onSubmit={createPerusahaan}>
                                                    <div className="row px-4 pt-3" style={{borderRadius:"10px"}}>
                                                        <div className="col-12 col-md-4 mb-3">
                                                            <label htmlFor="perusahaan">Perusahaan</label>
                                                            <input type="text" maxLength={300} id="perusahaan" className="form form-control" value={perusahaan} style={{fontSize:"11pt"}} readOnly required/>
                                                        </div>
                                                        <div className="col-12 col-md-4 mb-3">
                                                            <label htmlFor="alamatPerusahaan">Alamat Perusahaan</label>
                                                            <input type="text" maxLength={700} id="alamatPerusahaan" className="form form-control" value={alamatPerusahaan} onChange={(e)=>setAlamatPerusahaan(e.target.value)} style={{fontSize:"11pt"}} required/>
                                                        </div>
                                                        <div className="col-12 col-md-4 mb-3">
                                                            <label htmlFor="npwpPerusahaan">ID TKU</label>
                                                            <input type="number" id="npwpPerusahaan" className="form form-control" value={npwpPerusahaan} onChange={(e) => setNpwpPerusahaan(e.target.value)} style={{fontSize:"11pt"}} required/>
                                                        </div>
                                                        <div className="col-12 col-md-4 mb-3">
                                                            <label htmlFor="namaPenandatangananSpt">Nama Penandatanganan SPT</label>
                                                            <input type="text" maxLength={200} id="namaPenandatangananSpt" className="form form-control" value={namaPenandatangananSpt} onChange={(e)=>setNamaPenandatangananSpt(e.target.value)} style={{fontSize:"11pt"}} required/>
                                                        </div>
                                                        <div className="col-12 col-md-4 mb-3">
                                                            <label htmlFor="jabatanPenandatangananSpt">Jabatan Penandatanganan SPT</label>
                                                            <input type="text" maxLength={200} id="jabatanPenandatangananSpt" className="form form-control" value={jabatanPenandatangananSpt} onChange={(e)=>setJabatanPenandatangananSpt(e.target.value)} style={{fontSize:"11pt"}} required/>
                                                        </div>
                                                        <div className="col-12 col-md-4 mb-3">
                                                            <label htmlFor="npwpPenandatangananSpt">TIN</label>
                                                            <input type="number" id="npwpPenandatangananSpt" className="form form-control" value={npwpPenandatangananSpt} onChange={(e) => setNpwpPenandatangananSpt(e.target.value)} style={{fontSize:"11pt"}} required/>
                                                        </div>
                                                        <input type="submit" className="btn btn-webew-login mb-4 mt-2" value="Tambah/Ubah Data"/>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :<div>

                        {/* Pilih Periode */}
                        <PilihPeriode
                            bulan={bulan}
                            perusahaan={perusahaan}
                            tahunSekarang={tahun}
                        />

                    </div>

                }

            </div>
        </div>
    )
}

export default MenuKaryawanTetap